<app-nav-menu-mobile *ngIf="mobileMenuVisible"></app-nav-menu-mobile>

<nav class="nsw-main-nav js-mega-menu" id="main-nav" aria-label="Main menu" style="z-index:1;">	
	<ul class="nsw-main-nav__list">	 
		<li>
			<a routerLink="whatIsBeachwatch">
		  		<span>About Beachwatch</span>
			</a>    
		</li>
		<li>
			<a routerLink="waterMonitoring">
		  		<span>Water monitoring</span>
			</a>    
		</li>
		<li>
			<a routerLink="beachwatchPartners">
		  		<span>Beachwatch partners</span>
			</a>    
		</li>
		<li>
			<a routerLink="contactUs">
		  		<span>Contact us</span>
			</a>    
		</li>
		<li>
			<a routerLink="yourFavourites">
		  		<span>Your favourites</span>
			</a>    
		</li>
	</ul>
  </nav>
  